/* eslint-disable */
export default {
  noResultFoundFor: '找不到以下的結果',
  search: '搜尋',
} as const;

// @key: @#@"noResultFoundFor"@#@ @source: @#@"No result found for"@#@
// @key: @#@"search"@#@ @source: @#@"Search"@#@
